// Reduces a raw telemetry event stream down to "what did the student end up submitting" -
// the same CODE_*/TEST_CASE_RESULT reduction useReplayState.js does for its scrubbable
// timeline, minus the currentTime slicing, since a revisit view only needs the final state.
export function latestSubmissionFromEvents(events = []) {
  const reversed = [...events].reverse()

  const lastCodeEvent = reversed.find(
    (e) => e.type?.startsWith('CODE_') && e.payload?.code !== undefined
  )
  const code = lastCodeEvent?.payload?.code ?? ''

  const lastTestResult = reversed.find((e) => e.type === 'TEST_CASE_RESULT')
  let testResults = []
  if (lastTestResult?.payload) {
    const { passed_count, total_tests, detailed_results } = lastTestResult.payload
    if (detailed_results) {
      testResults = detailed_results
    } else if (passed_count !== undefined && total_tests !== undefined) {
      for (let i = 0; i < total_tests; i++) {
        testResults.push({ test_case_number: i + 1, passed: i < passed_count })
      }
    }
  }

  const lastError = reversed.find((e) => e.type === 'TERMINAL_ERROR')
  const terminalOutput = lastError?.payload
    ? [{ type: 'stderr', content: `${lastError.payload.type || 'Error'}: ${lastError.payload.message || ''}` }]
    : []

  return { code, testResults, terminalOutput }
}
